module.exports = __webpack_public_path__ + "static/assets/f5fe7b4329c7728162f3383154c25b4f.png";